import * as ngCore from '@angular/core'
import { ApolloSandbox } from '@apollo/sandbox'
import * as errors from '@attain-apps/errors'
import { environment } from '@attain-apps/fe/web/main/env'
import * as awsAmplifyAuth from 'aws-amplify/auth'

const INITIALIZATION_POLLING_INTERVAL_MS = 200

/**
 * @see
 * {@link https://www.apollographql.com/blog/how-to-use-apollo-sandbox-on-your-localhost},
 * {@link https://www.apollographql.com/docs/graphos/platform/explorer#embedding-sandbox}
 */
@ngCore.Component({
  selector: 'atn-gql-sandbox',
  standalone: true,
  styleUrls: ['./sandbox.component.scss'],
  templateUrl: './sandbox.component.html',
})
export class Component implements ngCore.AfterViewInit {
  ngAfterViewInit() {
    // Continually checks to see if the target element is ready (since logic in
    // various places, such as loading and deferring, may delay the actual
    // instantiation of the content)
    const interval = setInterval(() => {
      const elementId = 'graphql-sandbox'
      const element = document.getElementById(elementId)
      if (element) {
        clearInterval(interval)
        // Advanced options: https://www.apollographql.com/docs/studio/explorer/sandbox#embedding-sandbox
        new ApolloSandbox({
          endpointIsEditable: false,
          /**
           * @see {@link https://www.apollographql.com/docs/apollo-sandbox#options}
           */
          handleRequest: async (endpointUrl, options) => {
            // We need to get the authentication session so we can authenticate the request
            const session = await awsAmplifyAuth.fetchAuthSession()
            const accessToken = session.tokens?.accessToken.toString()
            if (!accessToken) {
              // We can only make a request if we have the access token
              throw new errors.AuthError(
                new Error('Failed to get access token'),
              )
            }
            // We add the authorization header to the request
            return fetch(endpointUrl, {
              ...options,
              headers: {
                ...options.headers,
                authorization: accessToken,
              },
            })
          },
          initialEndpoint: environment.graphqlEndpoint,
          runTelemetry: false,
          sendOperationHeadersInIntrospection: false,
          target: `#${elementId}`,
        })
      }
    }, INITIALIZATION_POLLING_INTERVAL_MS)
  }
}
